import { Heading, Link, Text } from 'components/ui';

type Props = {
  error: boolean;
};

export const LocationHeader = ({ error }: Props) => {
  return (
    <>
      <Heading fontSize={'2xl'}>What's your address?</Heading>

      {error && (
        <Text mt={7} fontSize={15} color="danger.500">
          Sorry, we are having trouble saving your address. Please try again or{' '}
          <Link
            _text={{ textTransform: 'lowercase' }}
            href="mailto:support@ayblehealth.com"
          >
            contact support
          </Link>{' '}
          if your problem persists.
        </Text>
      )}
    </>
  );
};
